export default __webpack_public_path__ + "static/media/mail.13f284bd.svg";